import BottomFloatingModal from "components/common/Modal/BottomFloatingModal";
import { useState } from "react";
import { useTranslation } from "next-i18next";
import useModalClickOutside from "utils/useModalClickOutside";
import { TYPO } from "styles/Typo";
import { Check } from "components/common/Icons";
import Button from "components/common/buttons/buttons";
import CustomToast from "components/atoms/CustomToast";
import { TAILWIND_TO_CSS } from "utils/constant/STYLE";
import { useDiscussIdContext } from "contexts/DiscussIdContext";
import { useModalClose } from "lib/analytics/react/modal";

function DebateAlarmRegisterModal({
  setModalOpen,
  isModalOpen,
  debateAlarmRegister,
}: {
  isModalOpen: boolean | "NEW" | "COMMENT";
  setModalOpen: any;
  debateAlarmRegister: any;
}) {
  const modalRef = useModalClickOutside(setModalOpen);
  const { t } = useTranslation("membership");
  const { trackClose } = useModalClose();
  const { discussId } = useDiscussIdContext();
  const [checkWarningToastVisible, setCheckWarningToastVisible] =
    useState(false);
  const [optionalCheckState, setOptionalCheckState] = useState(false);

  if (isModalOpen === "COMMENT") {
    return (
      <BottomFloatingModal
        isOpen={true}
        modalRef={modalRef}
        isIosFixedBottomButtonFlag={false}
      >
        <div className="flex flex-col gap-1 w-full">
          <div className="pt-6 px-6 pb-2 flex flex-col gap-1">
            <span
              className={` ${TYPO.TYPO4_B} text-gray80 whitespace-pre-line`}
            >
              {t(`내 의견에 반응이 달리면\n문자로 알려드릴까요?`)}
            </span>
          </div>

          <div className="flex flex-col py-2 px-6">
            <div
              className="flex items-center cursor-pointer gap-2 py-1"
              onClick={() => {
                setCheckWarningToastVisible(true);
              }}
              data-gtm-id={`report-alarm-modal-required-checkbox-comment`}
            >
              <div className="shrink-0">
                <Check
                  fill={true ? "blue40" : "gray30"}
                  height={20}
                  width={20}
                />
              </div>
              <span className={`${TYPO.TYPO7_MD} text-blue40`}>{"필수"}</span>
              <span className={`${TYPO.TYPO7_RG} text-gray70`}>
                {"댓글, 좋아요 알림 수신 동의"}
              </span>
            </div>
          </div>

          <div className="px-6 pb-6 flex flex-col gap-2">
            <Button
              clickHandler={() => {
                debateAlarmRegister(optionalCheckState, isModalOpen);
                setModalOpen(false);
              }}
              text={t("알림 받기")}
              size="xl"
              type={"primary"}
            />
            <Button
              btnClass="debate-alarm-register-modal-later-button"
              clickHandler={() => {
                const tomorrow = new Date();
                tomorrow.setDate(tomorrow.getDate() + 1);
                localStorage.setItem(
                  "hideCommentAlarmRegister",
                  tomorrow.toISOString()
                );
                setModalOpen(false);
              }}
              text={t("나중에")}
              size="xl"
              type={"text_gray"}
              dataGtmId={`report-comment-alarm-modal-later-button`}
            />
          </div>
        </div>
        <CustomToast
          message={t("꼭 동의해야 하는 항목이에요")}
          isVisible={checkWarningToastVisible}
          onClose={() => setCheckWarningToastVisible(false)}
          isSuccess={false}
          width={300}
          duration={1000}
        />
      </BottomFloatingModal>
    );
  } else {
    return (
      <BottomFloatingModal
        isOpen={true}
        modalRef={modalRef}
        isIosFixedBottomButtonFlag={false}
      >
        <div className="flex flex-col  w-full p-6 gap-[30px]">
          <div className="flex gap-4 items-center">
            <div className="rounded-[14.45px] w-[54px] h-[54px] bg-gray80 p-[5.4px] flex items-center justify-center">
              <SMSIcon />
            </div>
            <div>
              <p className={`${TYPO.TYPO7_RG} text-gray50`}>다 읽으셨네요!</p>
              <p
                className={`${TYPO.TYPO5_1_SB} text-gray80 whitespace-pre-line`}
              >{`다른 리포트가 올라오면\n알려드릴까요?`}</p>
            </div>
          </div>
          <div className="flex gap-2">
            <Button
              btnClass="debate-alarm-register-modal-later-button grow flex-1 !text-gray60"
              clickHandler={() => {
                trackClose("cancel");
                const tomorrow = new Date();
                tomorrow.setDate(tomorrow.getDate() + 1);
                localStorage.setItem(
                  "hideNewDebateAlarmRegister",
                  tomorrow.toISOString()
                );
                setModalOpen(false);
              }}
              text={t("닫기")}
              size="xl"
              type={"tertiary"}
              dataGtmId={`report-alarm-modal-later-button`}
            />
            <Button
              btnClass="grow flex-1 whitespace-nowrap"
              clickHandler={() => {
                debateAlarmRegister(
                  optionalCheckState,
                  isModalOpen,
                  "report_bs_alarm_cta",
                  Number(discussId)
                );
                trackClose("success");
                setModalOpen(false);
              }}
              text={t("문자로 알림 받기")}
              size="xl"
              type={"secondary"}
            />
          </div>
        </div>
        <CustomToast
          message={t("꼭 동의해야 하는 항목이에요")}
          isVisible={checkWarningToastVisible}
          onClose={() => setCheckWarningToastVisible(false)}
          isSuccess={false}
          width={300}
          duration={1000}
        />
      </BottomFloatingModal>
    );
  }
}

const SMSIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
    >
      <rect
        x="4.39062"
        y="7.99902"
        width="36"
        height="28.8"
        rx="7.2"
        fill="#CFD8E1"
      />
      <path
        d="M21.6279 22.6061C21.9834 22.3347 22.4759 22.3332 22.834 22.6012L38.584 34.3863C37.2653 35.8655 35.3465 36.7984 33.209 36.7984H11.6094C9.46368 36.7984 7.53783 35.8587 6.21875 34.3697L21.6279 22.6061Z"
        fill={TAILWIND_TO_CSS["gray5"]}
      />
      <path
        d="M33.724 7.99707H11.0573C7.37539 7.99707 4.39062 10.9818 4.39062 14.6637L17.6352 26.3141C20.3544 28.7059 24.4269 28.7059 27.146 26.3141L40.3906 14.6637C40.3906 10.9818 37.4059 7.99707 33.724 7.99707Z"
        fill={TAILWIND_TO_CSS["gray40"]}
      />
      <path
        d="M33.7906 7.99902H10.9906C7.34555 7.99902 4.39062 10.9539 4.39062 14.599L18.1328 24.6766C20.6671 26.5351 24.1141 26.5351 26.6484 24.6766L40.3906 14.599C40.3906 10.9539 37.4357 7.99902 33.7906 7.99902Z"
        fill={TAILWIND_TO_CSS["gray5"]}
      />
      <circle
        cx="37.6953"
        cy="8.89941"
        r="4.5"
        fill={TAILWIND_TO_CSS["red40"]}
      />
    </svg>
  );
};

export default DebateAlarmRegisterModal;
